import { render, staticRenderFns } from "./TableRowForhold.vue?vue&type=template&id=0a64eb2c"
import script from "./TableRowForhold.vue?vue&type=script&lang=js"
export * from "./TableRowForhold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports